export const formatCurrency = (amount, currency = 'INR') => {
  if (amount === null || amount === undefined) return currency === 'USD' ? '$0.00' : '₹0.00';
  
  const currencyCode = currency === 'USD' || currency === 'usd' ? 'USD' : 'INR';
  const locale = currencyCode === 'USD' ? 'en-US' : 'en-IN';
  
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currencyCode,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
};

// Shorthand for INR
export const formatINR = (amount) => formatCurrency(amount, 'INR');

// Shorthand for USD
export const formatUSD = (amount) => formatCurrency(amount, 'USD');

export const formatDate = (dateString) => {
  if (!dateString) return 'N/A';
  
  const date = new Date(dateString);
  
  // Handle invalid dates (e.g., from malformed Excel imports)
  if (isNaN(date.getTime())) return 'N/A';
  
  return new Intl.DateTimeFormat('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  }).format(date);
};

export const formatDateTime = (dateString) => {
  if (!dateString) return 'N/A';
  
  const date = new Date(dateString);
  
  // Handle invalid dates
  if (isNaN(date.getTime())) return 'N/A';
  
  return new Intl.DateTimeFormat('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(date);
};

export const formatMonth = (monthString) => {
  if (!monthString) return 'N/A';
  
  const [year, month] = monthString.split('-');
  const date = new Date(year, parseInt(month) - 1, 1);
  return new Intl.DateTimeFormat('en-GB', {
    month: 'long',
    year: 'numeric',
  }).format(date);
};

export const getCurrentMonth = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  return `${year}-${month}`;
};
